import React, { useState } from 'react';
import axios from "axios";
import {
  Card, CardBody, Col, Container, Input, Label, Row, Button, Form,
  FormFeedback, Alert, Spinner
} from 'reactstrap';
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import withRouter from "../../Components/Common/withRouter";
import logoLight from "../../assets/images/Logo_V2-2_white.png";


const validationSchema = Yup.object({
  email: Yup.string()
    .email("Email invalide")
    .required("Veuillez saisir votre email"),
});


const ForgotPassword = (_props: any) => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const validation = useFormik({
    initialValues: { email: "" },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setErrorMsg(null);
      setSuccessMsg(null);
      try {
        const res: any = await axios.post(
          "/apiV2/",
          { action: "forgotpassword", email: values.email },
          { headers: { "Content-Type": "application/json" } }
        );
        const payload = res?.data ?? res;
        if (payload?.success) {
          setSuccessMsg(
            payload?.message ||
              "Si cet email est enregistré, un lien de réinitialisation vient d'être envoyé."
          );
          validation.resetForm();
        } else {
          setErrorMsg(payload?.message || "Une erreur est survenue.");
        }
      } catch (e: any) {
        const msg =
          typeof e === "string"
            ? e
            : e?.response?.data?.message || e?.message || "Une erreur est survenue.";
        setErrorMsg(String(msg));
      } finally {
        setLoading(false);
      }
    },
  });

  document.title = "Mot de passe oublié | IP Trend";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="IP Trend" height="80" />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium">Votre espace client IP Trend</p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Mot de passe oublié ?</h5>
                      <p className="text-muted">
                        Saisissez votre email pour recevoir un lien de réinitialisation
                      </p>
                      <div className="mt-4 mb-2">
                        <i
                          className="ri-mail-send-line display-5"
                          style={{ color: "#0066A1" }}
                        ></i>
                      </div>
                    </div>

                    <Alert className="alert-borderless alert-warning text-center mb-2 mx-2" role="alert">
                      Entrez votre email et les instructions vous seront envoyées !
                    </Alert>

                    {errorMsg && (
                      <Alert color="danger" className="mt-3 mb-2 mx-2">
                        <i className="ri-error-warning-line me-2"></i>
                        {errorMsg}
                      </Alert>
                    )}
                    {successMsg && (
                      <Alert color="success" className="mt-3 mb-2 mx-2">
                        <i className="ri-checkbox-circle-line me-2"></i>
                        {successMsg}
                      </Alert>
                    )}

                    <div className="p-2">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-4">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="exemple@entreprise.fr"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              !!(validation.touched.email && validation.errors.email)
                            }
                          />
                          {validation.touched.email && validation.errors.email && (
                            <FormFeedback type="invalid">
                              {validation.errors.email as string}
                            </FormFeedback>
                          )}
                        </div>

                        <div className="text-center mt-4">
                          <Button
                            color="success"
                            className="btn btn-success w-100"
                            type="submit"
                            disabled={loading}
                          >
                            {loading && <Spinner size="sm" className="me-2">Chargement...</Spinner>}
                            <i className="ri-mail-send-line me-1"></i>
                            Envoyer le lien de réinitialisation
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>

                <div className="mt-4 text-center">
                  <p className="mb-0 text-dark">
                    Je me souviens de mon mot de passe...{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-dark text-decoration-underline"
                    >
                      Retour à la connexion
                    </Link>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(ForgotPassword);
